import { IPendingCertificate } from 'app_types/user/certificateTypes';
import { IUserData } from '../../types/userTypes';
export const ADD_INTERACTION = '[Interaction] ADD_INTERACTION'
export const DELETE_INTERACTION = '[Interaction] DELETE_INTERACTION'

export type TypesInteraction =
  'survey' |
  'update_profile_information' |
  'help_steps' |
  'characterization_survey' |
  'pending_certificate';

export interface IInteractionState{
  path?: IPathInteraction
}

export interface IPathInteraction{
  config_category: string
  survey: string
  academic_resource_config: string
  surveyRelated: string
  typeInteraction: TypesInteraction;
  shouldReplaceContent?: boolean
  surveyRelatedContent: {
    course_modes_mixed?: string,
    name: string,
    endDate: string
    teacher: Partial<IUserData>
  }
  pendingCertificate?: IPendingCertificate
}

interface IAddInteractionAction{
  type: typeof ADD_INTERACTION,
  payload: IPathInteraction
}

interface IDeleteInteractionAction{
  type: typeof DELETE_INTERACTION
}

export type IInteractionActionTypes = IAddInteractionAction | IDeleteInteractionAction
